import {inject, Injectable} from "@angular/core";
import {NetworkConnectionService} from "../../../../services/network-connection/network-connection.service";
import {map, skip, startWith} from "rxjs";

@Injectable({ providedIn: 'root' })
export class EntryViewerNetworkHandler {
  private readonly networkService = inject(NetworkConnectionService);

  readonly isOffline$ = this.networkService.onNetworkConnectionChanged$.pipe(
    skip(1),
    map(isConnected => !isConnected),
    startWith(false)
  );
}
